import { render, staticRenderFns } from "./listele.vue?vue&type=template&id=5087db36&scoped=true&"
import script from "./listele.vue?vue&type=script&lang=js&"
export * from "./listele.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087db36",
  null
  
)

export default component.exports